export default __webpack_public_path__ + "static/Industrial_Grinder-ea36b945c262eed8eda26105dfec4fe9.png";